export default "__VITE_ASSET__62283572__"